import { getElem } from "../utils";
import { config } from "../utils/settings";

class SoundController {
    private audioContext: AudioContext | null;
    private analyser: AnalyserNode | null;
    private microphone: MediaStreamAudioSourceNode | null;
    private dataArray: Uint8Array | null;
    private soundLevel: number;
    private soundUI: HTMLElement;
    private soundLevelFill: HTMLElement;

    constructor() {
        this.audioContext = null;
        this.analyser = null;
        this.microphone = null;
        this.dataArray = null;
        this.soundLevel = 0;
        this.soundUI = getElem('gauge-container');
        this.soundLevelFill = getElem('gauge-fill');
    }

    async setupMicrophone() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            
            this.audioContext = new (window.AudioContext || (<any>window).webkitAudioContext)();
            this.analyser = this.audioContext.createAnalyser();
            this.microphone = this.audioContext.createMediaStreamSource(stream);
            
            this.microphone.connect(this.analyser);
            this.analyser.fftSize = 256;

            this.soundUI.style.bottom = "50px";
            
            const bufferLength = this.analyser.frequencyBinCount;
            this.dataArray = new Uint8Array(bufferLength);
            
            return stream; // Return the stream for video recording
        } catch (error) {
            console.error('Error accessing microphone:', error);
            throw new Error('Microphone access denied');
        }
    }

    toggleSoundBar(state: boolean) {
        this.soundUI.style.bottom = state ? "50px":"-100px";
    }

    updateSoundLevel() {
        if (!this.analyser || !this.dataArray) return 0;
        
        // Analyze sound input
        this.analyser.getByteFrequencyData(this.dataArray);
        
        // Calculate average sound level (0-1)
        let sum = 0;
        for (let i = 0; i < this.dataArray.length; i++) {
            sum += this.dataArray[i];
        }
        this.soundLevel = sum / (this.dataArray.length * 255);
        this.soundLevel = this.soundLevel * config.sound.amp; // Amplify sound level
        
        // console.log(this.soundLevel);
        // Update sound level indicator
        this.soundLevelFill.style.width = `${(this.soundLevel * 100) + 5}%`;
        
        return this.soundLevel;
    }

    getSoundLevel() {
        return this.soundLevel;
    }

}

export default SoundController;